<template>
  <div class="collaboration-page">
    <!-- <h1>委託與合作</h1> -->
    <ParkingManagementForm />
    <ContactFooter />
  </div>
</template>

<script>
import ParkingManagementForm from '@/components/ParkingManagementForm.vue'
import ContactFooter from '@/components/ContactFooter.vue'

export default {
  name: 'CollaborationPage',
  components: {
    ParkingManagementForm, 
    ContactFooter
  }
}
</script>

<style scoped>
.collaboration-page {
  /* padding: 20px; */
  margin-top:0px;
  background-color: var(--background-gray);
  width:100%;
}


</style>